import { collection, doc, getDoc, getDocs, onSnapshot, query, runTransaction, updateDoc, where } from 'firebase/firestore';
import { Notification } from '../models/Notification';
import { Room } from '../models/Room';
import { RoomCall } from '../models/RoomCall';
import { JoinedOrCreated, NotifyUsersOnNewVoiceCall } from '../models/local/Types';
import { User } from '../models/User';
import { FireClient, getFunc } from './FireClient';
import { Util } from './Utils/Util';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

export class FireClientCall {
  constructor(private c: FireClient) {
  }

  async getRoomAndToken(identity: string, roomId: string): Promise<string> {
    // roomId will become the Twilio room name.
    // let func = getFunc('makeRoomAndGetTwilioToken');
    const functions = getFunctions(getApp(), 'asia-northeast1');
    // functions.region = FB_REGION;
    const func = httpsCallable(functions, "makeRoomAndGetTwilioToken", { timeout: 535 * 1000 });
    let res = await func({ identity, roomId, roomType: 'group', audioOnly: false }) as any;
    return res.data.token as string;
  }

  async createOrJoinRoomCall(room: Room, user: User, notify: NotifyUsersOnNewVoiceCall): Promise<JoinedOrCreated> {
    return await runTransaction(this.c.store, async (t) => {
      let ref = doc(this.c.store, RoomCall.COL, room.id);
      let d = await t.get(ref); //await getDoc(ref);
      if (d.exists()) {
        // Join
        let rc = d.data() as RoomCall;
        RoomCall.addUser(rc, user);
        await t.update(ref, Util.pojo(rc));
        return 'joined';
      } else {
        // Create
        let rc = new RoomCall(room);
        RoomCall.addUser(rc, user);
        await t.set(ref, Util.pojo(rc));

        if (notify == 'notify-all-members') {
          rc.room.userIds.forEach(uid => {
            if (uid != user.id) {
              let user = rc.users.length > 0 ? rc.users[0] : null;
              let notif = new Notification('CallStart', uid, rc.room.id, rc.room.name, null, null, null, user);
              t.set(doc(this.c.store, Notification.COL, notif.id), Util.pojo(notif));
            }
          })
        }
        return 'created';
      }
    });
  }

  async leaveRoomCall(roomId: string, userId: string) {
    return await runTransaction(this.c.store, async (t) => {
      let ref = doc(this.c.store, RoomCall.COL, roomId);
      let d = await t.get(ref)
      if (d.exists()) {
        let rc = d.data() as RoomCall;
        RoomCall.removeUser(rc, userId);
        if (rc.userIds.length == 0) {
          await t.delete(ref);
        } else {
          await t.update(ref, Util.pojo(rc));
        }
      }
    });
  }

  subscribeToRoomCall(roomId: string, handler: (rc: RoomCall) => void) {
    let ref = doc(this.c.store, RoomCall.COL, roomId);
    const unsubscribe = onSnapshot(ref, (snap) => {
      handler(snap.data() as RoomCall);
    });
    return unsubscribe;
  }

  subscribeToRoomCalls(userId: string, handler: (rcs: RoomCall[]) => void) {
    const q = query(collection(this.c.store, RoomCall.COL), where("room.userIds", 'array-contains', userId));
    const unsubscribe = onSnapshot(q, (snaps) => {
      let rcs = snaps.docs.map(d => d.data() as RoomCall);
      handler(rcs);
    });
    return unsubscribe;
  }


  updateRoomCall(roomCall: RoomCall) {
    roomCall.updated = new Date();
    let ref = doc(this.c.store, RoomCall.COL, roomCall.room.id);
    return updateDoc(ref, Util.pojo(roomCall));
  }

  getRoomCall(roomId: string): Promise<RoomCall> {
    let ref = doc(this.c.store, RoomCall.COL, roomId);
    return getDoc(ref).then(d => d.data() as RoomCall);
  }

  async getJoinedRoomCalls(userId: string): Promise<RoomCall[]> {
    const q = await getDocs(query(collection(this.c.store, RoomCall.COL), where("userIds", 'array-contains', userId)));
    return q.docs.map(d => d.data() as RoomCall);
  }
}

    // firebase.auth()
    //   .getRedirectResult()
    //   .then(async (result) => {
    //     console.log("getRedirectResult");
    //     if (result.credential) {
    //       /** @type {firebase.auth.OAuthCredential} */
    //     }
    //     if (result.user) {
    //       const existing = await this.store.collection('users').doc(result.user.uid).get();
    //       if (!existing.exists) {
    //         const appUser = Util.fireUserToUser(result.user)
    //         await this.store.collection('users').doc(appUser?.id).set(Util.toPOJO(appUser));
    //         handler(Util.toPOJO(appUser));
    //         console.log("Stored a new user")
    //       }
    //     }
    //   }).catch((error) => {
    //     // var errorCode = error.code;
    //     // var errorMessage = error.message;
    //     // var email = error.email;
    //     // var credential = error.credential;
    //     console.log("getRedirectResult threw error.");
    //     console.error(error);
    //   });
